// Patient Registartion Required Fields JSON configurations
import choremeioFieldsConfig from './components/choremeioFields.config.json';
import { ProjectFeaturesConfig } from './components/project-features.config';
import projectFeaturesConfig from './components/project-features.config.json';

// type definitions
import { NestedKeys, NestedValue, ConfigMap } from './config-type-utils.d';

// -----------------------------------------------------------------------------
class DynamicConfigService {
  static #instance: DynamicConfigService | null = null;
  #configMap: { [K in keyof ConfigMap]: ConfigMap[K] } = {
    choremeioFields: choremeioFieldsConfig,
    projectFeatures: projectFeaturesConfig as ProjectFeaturesConfig,
  };

  // ---------------------------------------------------------------------------
  public static getInstance(): DynamicConfigService {
    if (!this.#instance) {
      this.#instance = new DynamicConfigService();
    }

    return this.#instance;
  }

  // ---------------------------------------------------------------------------
  // Generic method to fetch configurations
  getConfig<T extends keyof ConfigMap, K extends NestedKeys<ConfigMap[T]>>(
    configKey: T,
    key?: K
  ): K extends undefined ? ConfigMap[T] : NestedValue<ConfigMap[T], K> {
    const config = this.#configMap[configKey];
    if (!key) {
      return config as any;
    }

    return this.#getNestedValue(config, key as string) as any;
  }

  // ---------------------------------------------------------------------------
  #getNestedValue<T, K extends string>(obj: T, key: K): NestedValue<T, K> {
    const parts = key.split('.');
    let current: any = obj;
    for (const part of parts) {
      if (current[part] === undefined) {
        return undefined as any;
      }

      current = current[part];
    }

    return current as NestedValue<T, K>;
  }

  // ---------------------------------------------------------------------------
  // optional dynamic loading of configurations
  // this would require making getConfig() async
  // async #loadConfig<T extends keyof ConfigMap>(
  //   configKey: T,
  // ): Promise<ConfigMap[T]> {
  //   const config = await import(`./${configKey}/${configKey}.config.json`);

  //   return config.default as ConfigMap[T];
  // }
}

export default DynamicConfigService;
